var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex mb-2", staticStyle: { "margin-bottom": "10px" } },
    [
      _vm.message.owner ? _c("v-spacer") : _vm._e(),
      _c(
        "v-card",
        {
          class: _vm.message.owner ? "chat-right" : "chat-left",
          staticStyle: { "max-width": "calc(100% - 32px)" }
        },
        [
          _c(
            "v-card-text",
            [
              _vm.message.sender_name && !_vm.message.owner
                ? _c("p", { staticClass: "m-0 text-dark" }, [
                    _vm._v(" " + _vm._s(_vm.message.sender_name) + " ")
                  ])
                : _vm._e(),
              _c("p", { staticClass: "m-0" }, [
                _vm._v(_vm._s(_vm.message.mensagem))
              ]),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c("div", _vm._g({}, on), [
                            _vm.message.data_registro
                              ? _c(
                                  "small",
                                  { staticClass: "text-secondary chat-time" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.message.data_registro,
                                            "HH:mm"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("small", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatDate(_vm.message.data_registro)) +
                        " "
                    )
                  ])
                ]
              ),
              !_vm.message.data_registro
                ? _c(
                    "small",
                    { staticClass: "text-secondary chat-time" },
                    [
                      _c("v-icon", { attrs: { "x-small": "" } }, [
                        _vm._v("mdi-clock-outline")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.message.trigger_action
            ? _c(
                "v-btn",
                {
                  staticClass: "m-5 mt-0",
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.doAction(_vm.message)
                    }
                  }
                },
                [_vm._v(" Ver mais ")]
              )
            : _vm._e()
        ],
        1
      ),
      !_vm.message.owner ? _c("v-spacer") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }